import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  UserTemporaryMailRequestBody,
  UserTemporaryMailResponse,
} from "./types";

export class UserTemporaryMailAPI extends BaseAPI<
  UserTemporaryMailRequestBody,
  UserTemporaryMailResponse
> {
  protected route = ApiRoutes.auth.temporary_mail;
  protected method = RequestMethod.POST;
}
